module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"instruction":"Plasser i riktig boks"},"en":{"instruction":"Put items in the right place"}}')
  delete Component.options._Ctor
}
